import React from "react";
import { QUIZ_BANNER_DISCLAIMER } from "../../lib/content";
import { Link } from "react-router-dom";

/**
 * Small in-context disclaimer banner shown on all quiz + photo screens.
 */
export function DisclaimerBanner() {
    return (
        <div
            className="rounded-xl bg-white/70 px-4 py-3 text-[13px] leading-snug text-meow-muted"
            data-testid="quiz-disclaimer-banner"
        >
            <span className="text-meow-charcoal/80">{QUIZ_BANNER_DISCLAIMER}</span>{" "}
            <Link
                to="/disclaimer"
                className="font-medium text-meow-teal underline-offset-2 hover:underline"
                data-testid="quiz-disclaimer-link"
            >
                Full medical disclaimer
            </Link>
        </div>
    );
}
